import { Controller } from '@hotwired/stimulus';

// Profile popover behaviour: opens on button click, closes on outside
// click, Escape or when the window loses focus. The popover is anchored
// to the component root.
export default class extends Controller {
  static targets = ['menu', 'button'];

  connect() {
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    this.handleWindowBlur = this.handleWindowBlur.bind(this);
  }

  disconnect() {
    this.close();
  }

  toggle() {
    if (this.menuTarget.hidden) {
      this.open();
    } else {
      this.close();
    }
  }

  open() {
    this.menuTarget.hidden = false;
    this.buttonTarget.setAttribute('aria-expanded', 'true');
    document.addEventListener('pointerdown', this.handleOutsideClick, true);
    document.addEventListener('keydown', this.handleKeydown);
    window.addEventListener('blur', this.handleWindowBlur);
  }

  close() {
    if (!this.hasMenuTarget || this.menuTarget.hidden) return;

    this.menuTarget.hidden = true;
    this.buttonTarget.setAttribute('aria-expanded', 'false');
    document.removeEventListener('pointerdown', this.handleOutsideClick, true);
    document.removeEventListener('keydown', this.handleKeydown);
    window.removeEventListener('blur', this.handleWindowBlur);
  }

  handleOutsideClick(event) {
    if (this.element.contains(event.target)) return;
    this.close();
  }

  handleKeydown(event) {
    if (event.key !== 'Escape') return;
    this.close();
    this.buttonTarget.focus();
  }

  // Without this, switching to another window leaves the menu open while
  // the sidebar collapses (its :focus-within expansion drops), clipping
  // the menu to the 72px rail. Blurring the button also keeps the sidebar
  // collapsed when the window regains focus.
  handleWindowBlur() {
    this.close();
    this.buttonTarget.blur();
  }
}
